package com.partejar.app.feature.gestantes.data.remote

import kotlinx.serialization.Serializable

@Serializable
data class GestantesPageDto(
    val content: List<GestanteListItemDto> = emptyList(),
    val page: Int,
    val size: Int,
    val totalElements: Long,
    val totalPages: Int,
    val last: Boolean
)

@Serializable
data class GestanteListItemDto(
    val pacienteId: Long,
    val nomeGestante: String,
    val nomeBebe: String? = null,
    val dataProvavelParto: String? = null,
    val dataParto: String? = null,
    val idadeGestacional: GestanteAgeDto? = null,
    val diasAteDpp: Long? = null,
    val responsavelPrincipal: GestanteResponsibleDto? = null,
    val statusAtual: String,
    val situacaoOperacional: GestanteOperationalStatusDto
)

@Serializable
data class GestanteAgeDto(val semanas: Int, val dias: Int)

@Serializable
data class GestanteResponsibleDto(val membroWorkspaceId: Long, val nome: String)

@Serializable
data class GestanteOperationalStatusDto(
    val status: String,
    val pendencias: List<String> = emptyList()
)

@Serializable
data class GestanteDetailDto(
    val pacienteId: Long,
    val nomeGestante: String,
    val nomeBebe: String? = null,
    val enderecoCep: String? = null, val enderecoLogradouro: String? = null,
    val enderecoNumero: String? = null, val enderecoComplemento: String? = null,
    val enderecoBairro: String? = null, val enderecoCidade: String? = null,
    val enderecoUf: String? = null,
    val dataProvavelParto: String? = null,
    val idadeGestacional: GestanteAgeDto? = null,
    val diasAteDpp: Long? = null,
    val maternidadeEscolha: String? = null,
    val tipoPreNatal: String? = null,
    val moraEmBh: Boolean,
    val responsavelPrincipal: GestanteResponsibleDto? = null,
    val statusAtual: String,
    val comorbidades: List<GestanteComorbidadeDto> = emptyList(),
    val parto: GestanteDeliveryDto? = null
)

@Serializable data class GestanteDeliveryDto(val id: Long, val dataParto: String, val horaParto: String? = null, val viaParto: String, val localParto: String, val desfechoMaterno: String, val desfechoNeonatal: String, val observacao: String? = null, val registradoPor: String)
@Serializable data class RegisterGestanteDeliveryDto(val dataParto: String, val horaParto: String? = null, val viaParto: String, val localParto: String, val desfechoMaterno: String, val desfechoNeonatal: String, val observacao: String? = null)

@Serializable
data class GestanteComorbidadeDto(
    val id: Long,
    val descricao: String,
    val observacao: String? = null,
    val ativa: Boolean
)

@Serializable
data class GestanteClinicalUpdateDto(
    val nomeBebe: String? = null,
    val enderecoCep: String? = null, val enderecoLogradouro: String? = null,
    val enderecoNumero: String? = null, val enderecoComplemento: String? = null,
    val enderecoBairro: String? = null, val enderecoCidade: String? = null,
    val enderecoUf: String? = null,
    val dataProvavelParto: String? = null,
    val maternidadeEscolha: String? = null,
    val tipoPreNatal: String? = null,
    val moraEmBh: Boolean
)

@Serializable
data class CriarComorbidadeDto(val descricao: String, val observacao: String? = null)

@Serializable
data class AtualizarComorbidadeDto(val observacao: String? = null)

@Serializable
data class GestanteExamTypeDto(
    val id: Long, val nome: String, val categoria: String,
    val codigo: String? = null, val ativo: Boolean = true,
    val analises: List<GestanteExamAnalysisDto> = emptyList()
)

@Serializable
data class GestanteExamCatalogDto(val tipos: List<GestanteExamTypeDto>)

@Serializable
data class GestanteExamAnalysisDto(
    val id: Long, val codigo: String, val nome: String, val definicao: String,
    val loincCodigo: String? = null, val unidadeObrigatoria: Boolean,
    val evolucaoHabilitada: Boolean, val ativo: Boolean,
    val unidades: List<GestanteExamUnitDto>
)

@Serializable
data class GestanteExamUnitDto(
    val id: Long, val codigo: String, val codigoUcum: String? = null,
    val rotulo: String, val padrao: Boolean, val ativo: Boolean
)

@Serializable
data class GestanteExamResultDto(
    val id: Long,
    val parametro: String,
    val valor: String,
    val unidade: String? = null,
    val referencia: String? = null,
    val status: String,
    val analiseId: Long? = null,
    val analiseUnidadeId: Long? = null,
    val resultadoLivre: Boolean = false,
    val evolucaoHabilitada: Boolean = false
)

@Serializable
data class GestanteExamDto(
    val id: Long,
    val tipo: GestanteExamTypeDto,
    val realizadoEm: String,
    val statusAvaliacao: String,
    val observacao: String? = null,
    val registradoPor: String,
    val resultados: List<GestanteExamResultDto> = emptyList()
)

@Serializable
data class GestanteExamResultInputDto(
    val parametro: String,
    val valor: String,
    val unidade: String? = null,
    val referencia: String? = null,
    val status: String,
    val analiseId: Long? = null,
    val analiseUnidadeId: Long? = null,
    val resultadoLivre: Boolean? = null
)

@Serializable
data class CreateGestanteExamDto(
    val exameTipoId: Long?,
    val realizadoEm: String,
    val observacao: String? = null,
    val resultados: List<GestanteExamResultInputDto> = emptyList(),
    val nomeExame: String? = null
)
